export const getCurrencyFormatOptions = ():
  | Intl.NumberFormatOptions
  | undefined => {
  return {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  };
};
